import {useState,  useEffect, useRef} from 'react';
import {updateUTCDate, showToast} from '../../common/app_common.js';
import {PageNation} from '../../common/component_common.js';
import Button from 'react-bootstrap/Button';
import {getApiReceiveEdgeKeyword, getApiReceiveEdge, getApiReceiveEdgeCount, getApiReceiveEdgeId, putApiReceiveEdgeIdStatus} from '../../common/fetch_api/coverage.js'
import {DecideWindow} from '../../common/modal_common.js';
import {BsPencilSquare, BsTrash, BsExclamationCircle, BsChevronExpand} from 'react-icons/bs';
import {ReceiveEdgeEditModal, ReceiveEdgeDetailModal} from './modals.js'

const PAGE_PER = 16;

export const View = ({update, runUpdate}) => {
    
    const [filterSort, setFilterSort] = useState('asc');
    const [filterCategory, setFilterCategory] = useState('');
    const [filterValue, setFilterValue] = useState('');
    const [filterList, setFilterList] = useState([]);
    const [filterDisable, setFilterDisable] = useState({disabled:true});

    const [edgeSelCount, setEdgeSelCount] = useState(1);
    const [curPageState, setCurPageState] = useState(1);
    const curPageRef = useRef(0);

    const [modalEdgeDetail, setModalEdgeDetail] = useState(false);
    const closeModalEdgeDetail = () => setModalEdgeDetail(false);
    const showModalEdgeDetail = (info) =>
    {
        setModalEdgeInfo(info);
        setModalEdgeDetail(true);
    };

    const [modalEdgeEdit, setModalEdgeEdit] = useState(false);
    const [modalEdgeInfo, setModalEdgeInfo] = useState(null);
    const closeModalEdgeEdit = () => setModalEdgeEdit(false);
    const showModalEdgeEdit = (info) =>
    {
        setModalEdgeInfo(info);
        setModalEdgeEdit(true);
    };

    const [accpetedList, setAcceptedList] = useState([]);
    
    const [decideBody, setDecideBody] = useState(null);
    const [decideBtn, setDecideBtn] = useState('OK');
    const [modalDecide, setModalDecide] = useState(false);
    const closeModalDecide = () => setModalDecide(false);
    const showModalDecide = (info) =>
    {
        setModalEdgeInfo(info);

        setDecideBtn('Remove');
        setDecideBody(
            <div className='text-center'>
                <p>Are you sure you want to remove this Edge?</p>
                <p>The remove Edge will be moved to Pending.</p>   
            </div>
        );
        
        setModalDecide(true);
    }

    const onClickAction = (is) => {
        if( is )
        {
            Promise.resolve( putApiReceiveEdgeIdStatus(modalEdgeInfo.id, 'dismiss') )
            .then( done => {
                runUpdate();
            })
            .catch( err => {});
        }
    }

    function getUtcTime(sec)
    {
        let checkIn = new Date(0);
        checkIn.setUTCSeconds(sec);
        const result = updateUTCDate(checkIn);

        return result;
    }

    function getOverTime(sec)
    {
        let curTime = new Date();
        let checkIn = new Date(0);
        checkIn.setUTCSeconds(sec);

        if( curTime.getTime() - checkIn.getTime() >= 60000 )
        {
            return "text-warning";
        }

        return '';
    }

    function toggleSort()
    {
        if( filterSort === 'asc' )
        {
            setFilterSort('desc');
        }
        else
        {
            setFilterSort('asc');
        }

        runUpdate();
    }

    function onChangeFilterCategory(e)
    {
        let category = e.target.value;

        setFilterCategory(category);

        if( category === 'all' )
        {
            setFilterDisable({disabled:true});
            setFilterList([]);
            setFilterValue('');
        }
        else if( category === 'product' )
        {
            setFilterDisable({disabled:false});

            Promise.resolve( getApiReceiveEdgeKeyword() )
            .then( data => {
                setFilterList(
                    data.product.map( (item, idx) => (
                        <option key={`${item}_${idx}`} value={item}>{item}</option>
                    ))
                );

                setFilterValue(data.product[0]);
            })
        }
    }

    function onChangeFilterValue(e)
    {
        setFilterValue(e.target.value);
    }

    function getReceiveEdges()
    {
        curPageRef.current.value = curPageState;
            
        Promise.resolve( getApiReceiveEdgeCount('accepted', filterValue) )
        .then( count => {
            
            if(count && count.count > 0)
            {
                setEdgeSelCount(count.count);
                
                let page = Math.ceil(count.count/PAGE_PER);
                if( curPageState > page )
                {
                    setCurPageState(page);
                }
                else
                {
                    page = curPageState;
                }
            
                Promise.resolve( getApiReceiveEdge(PAGE_PER, page, 'accepted', filterValue, 'name', filterSort) )
                .then( edgeIds => {

                    let api = [];
                    for( const id of edgeIds )
                    {
                        api.push( getApiReceiveEdgeId(id) );
                    }

                    Promise.all( api )
                    .then( data => {
                        setAcceptedList( data.map((item, idx) => (
                            <tr key={item.id}>
                                <td>{item.name}</td>
                                <td>{item.product}</td>
                                <td>{item.id}</td>
                                <td>{item.fingerprint}</td>
                                <td className={getOverTime(item.sec)}>{getUtcTime(item.sec)}</td>
                                <td>{item.clientIp}</td>
                                <td>
                                    <Button variant="primary" className="btn btn-icon" onClick={() => {showModalEdgeDetail(item)}}><BsExclamationCircle/></Button>
                                </td>
                                <td>
                                    <Button variant="secondary" className="btn btn-icon" onClick={() => {showModalEdgeEdit(item)}}><BsPencilSquare/></Button>
                                </td>
                                <td>
                                    <Button variant="danger" className="btn btn-icon" onClick={() => {showModalDecide(item)}}><BsTrash/></Button>
                                </td>
                            </tr>
                        )));
                    });
                });
            }
        });
    }

    const ContentsHeader = () => {
        return (
            <thead>
                <tr>
                    <th className="sorting" sort-type='name' onClick={toggleSort}>Name<BsChevronExpand /></th>
                    <th>Product</th>
                    <th>ID</th>
                    <th>Fingerprint</th>
                    <th>Latest Check in</th>
                    <th>Client IP</th>
                    <th></th>
                    <th></th>
                    <th></th>
                </tr>
            </thead>
        );
    };

    useEffect( () => {
        getReceiveEdges();
    }, [update, filterValue, curPageState]);

    return (
        <>
            <div className="d-flex edges-search-select mt-2">
                <select className="form-select form-select-sm" value={filterCategory} onChange={onChangeFilterCategory}>
                    <option value="all">All</option>
                    <option value="product">Product</option>
                </select>
                <select className="form-select form-select-sm ms-2" {...filterDisable} value={filterValue} onChange={onChangeFilterValue}>
                    {filterList}
                </select>
            </div>
            <div className="section receive-edge-area mt-2">
                <table className="table">
                    <ContentsHeader/>
                    <tbody id='acceptTbody'>
                        {accpetedList}
                    </tbody>
                </table>
            </div>
            <PageNation
                curPageState={curPageState}
                setCurPageState={setCurPageState}
                selCount={edgeSelCount}
                pagePer={PAGE_PER}
                ref={curPageRef}
            ></PageNation>
            {modalEdgeEdit&&<ReceiveEdgeEditModal edgeInfo={modalEdgeInfo} show={modalEdgeEdit} handleClose={closeModalEdgeEdit} update={runUpdate}></ReceiveEdgeEditModal>}
            {modalEdgeDetail&&<ReceiveEdgeDetailModal edgeInfo={modalEdgeInfo} show={modalEdgeDetail} handleClose={closeModalEdgeDetail} update={runUpdate}></ReceiveEdgeDetailModal>}
            {modalDecide&&<DecideWindow result={onClickAction} show={modalDecide} handleClose={closeModalDecide} body={decideBody} okButtonTxt={decideBtn}></DecideWindow>}
        </>
    );
};